var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3825 30.3333H11.7425C9.22249 30.3333 7.38249 29.28 6.67582 27.4667C5.94249 25.5733 6.62249 23.2267 8.38249 21.64L14.5692 16L8.38249 10.36C6.62249 8.77334 5.94249 6.42667 6.67582 4.53334C7.38249 2.70667 9.22249 1.66667 11.7425 1.66667H20.3825C22.9025 1.66667 24.7425 2.72001 25.4492 4.53334C26.1825 6.42667 25.5025 8.77334 23.7425 10.36L17.5558 16L23.7558 21.64C25.5025 23.2267 26.1958 25.5733 25.4625 27.4667C24.7425 29.28 22.9025 30.3333 20.3825 30.3333ZM16.0625 17.3467L9.72915 23.1067C8.60915 24.1333 8.11582 25.6267 8.54249 26.7333C8.94249 27.76 10.0758 28.3333 11.7425 28.3333H20.3825C22.0492 28.3333 23.1825 27.7733 23.5825 26.7333C24.0092 25.6267 23.5292 24.1333 22.3958 23.1067L16.0625 17.3467ZM11.7425 3.66667C10.0758 3.66667 8.94249 4.22667 8.54249 5.26667C8.11582 6.37334 8.59582 7.86667 9.72915 8.89334L16.0625 14.6533L22.3958 8.89334C23.5158 7.86667 24.0092 6.37334 23.5825 5.26667C23.1825 4.24001 22.0492 3.66667 20.3825 3.66667H11.7425Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.70b5bb82.svg";
export { ForwardRef as ReactComponent };